// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__UGXjL"};